<div
  class="min-w-28 w-auto absolute right-7 background-gradient rounded-b-2xl z-50"
  [ngClass]="{
    'rounded-t-2xl -top-10': isOffer() && showCountDown(),
  }"
>
  @if (isOffer() && showCountDown()) {
    <div
      class="h-10 w-auto shadow-lg flex items-center justify-center border-b border-[--color-gray-3] rounded-t-2xl px-2"
    >
      <p class="text-center text-sm text-white font-bold">{{ shortText }}</p>
    </div>
  }
  <div
    class="h-10 w-auto shadow-lg flex items-center justify-center px-2 rounded-b-2xl"
    [ngClass]="{ ' top-0': !isOffer() }"
  >
    @if (showCountDown()) {
      <lib-countdown
        (countdownIsOver)="countdownIsOver.set(true)"
        titleCss="text-sm font-bold text-white"
        [showTexts]="false"
        [countdownDateFromPrismic]="countdownDate()"
      >
      </lib-countdown>
    } @else {
      <p class="text-center text-sm text-white font-bold">{{ shortText }}</p>
    }
  </div>
</div>
